export interface NavItem {
  label: string;
  to: string;
}

export const MAIN_NAV: NavItem[] = [
  { label: "Accueil", to: "/" },
  { label: "Fonctionnalités", to: "/fonctionnalites" },
  { label: "Solutions", to: "/solutions" },
  { label: "Tarifs", to: "/tarifs" },
  { label: "FAQ", to: "/faq" },
];

export const FOOTER_NAV: { title: string; items: NavItem[] }[] = [
  {
    title: "Produit",
    items: [
      { label: "Fonctionnalités", to: "/fonctionnalites" },
      { label: "Tarifs", to: "/tarifs" },
      { label: "Comment ça marche", to: "/comment-ca-marche" },
      { label: "FAQ", to: "/faq" },
    ],
  },
  {
    title: "Solutions",
    items: [
      { label: "Propriétaires", to: "/solutions" },
      { label: "Agences immobilières", to: "/solutions" },
    ],
  },
  {
    title: "Entreprise",
    items: [
      { label: "À propos", to: "/a-propos" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Légal",
    items: [
      { label: "Mentions légales", to: "/mentions-legales" },
      { label: "Politique de confidentialité", to: "/confidentialite" },
      { label: "CGU", to: "/cgu" },
      { label: "CGV", to: "/cgv" },
      { label: "Politique cookies", to: "/cookies" },
      { label: "Abonnement", to: "/abonnement" },
    ],
  },
];